var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.0003C12.5 10.1775 12.4245 10.3474 12.2903 10.4726L8.71264 13.8125C8.57768 13.9342 8.39694 14.0015 8.20932 14C8.02171 13.9985 7.84224 13.9282 7.70957 13.8044C7.5769 13.6805 7.50166 13.513 7.50003 13.3378C7.4984 13.1627 7.57052 12.994 7.70086 12.868L10.7734 10.0003L7.70086 7.13203C7.57052 7.00605 7.4984 6.83732 7.50003 6.66218C7.50166 6.48703 7.5769 6.3195 7.70957 6.19565C7.84224 6.0718 8.02171 6.00155 8.20932 6.00003C8.39694 5.9985 8.57768 6.06583 8.71264 6.18751L12.2903 9.5274C12.3569 9.5895 12.4096 9.66323 12.4456 9.74438C12.4816 9.82553 12.5001 9.91251 12.5 10.0003Z",
    fill: "#808690"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExpand);
export default __webpack_public_path__ + "static/media/menu_expand.da40672e973071824856b9591df75681.svg";
export { ForwardRef as ReactComponent };